import styled from 'styled-components';
import Icon from '../../Icon/Icon.component';

interface ContainerMessageProps {
  isPresentMessage: boolean | undefined;
  hasOnlyNotesBelow?: boolean;
  height?: string;
  padding?: string;
  paddingWithNotes?: string;
}

export const IconInsideInput = styled(Icon)`
  position: absolute;
  right: 0;
  margin-right: 10px;
  bottom: 10px;
  display: none;
`;

export const MessageError = styled.span`
  position: absolute;
  color: inherit;
  display: none;
  font-size: inherit;
  font-weight: 400;
`;

export const DefaultMessage = styled.span`
  display: block;
  font-size: inherit;
  font-weight: 400;
  color: gray;
`;

export const ContainerMessage = styled.div<ContainerMessageProps>`
  display: flex;
  align-items: center;
  height: ${({ hasOnlyNotesBelow, height }) => {
    return hasOnlyNotesBelow ? 'unset' : height;
  }};
  font-size: 16px;
  line-height: 1.1875;
  ${({ isPresentMessage, hasOnlyNotesBelow }) => {
    if (isPresentMessage) {
      return `
        & > ${MessageError} {
          display:block;
          position: ${hasOnlyNotesBelow ? 'unset' : 'absolute'}
        }
      `;
    }
    return '';
  }}
  padding: ${({ hasOnlyNotesBelow, padding, paddingWithNotes }) => {
    return hasOnlyNotesBelow ? paddingWithNotes : padding;
  }};
`;

ContainerMessage.defaultProps = {
  height: '30px',
  padding: '5px 0 0',
  paddingWithNotes: '5px 0 24px',
};
